module.exports = __webpack_public_path__ + "media/images/lig/uxu-customer-1-a53cfdb199154830f21be526b1e9ef45.jpg";